// extracted by mini-css-extract-plugin
export default {"autosizeTextInputContainer":"autosize-text-input-module__autosizeTextInputContainer__uAQ6Hab"};